import { render, staticRenderFns } from "./StockIndicator.vue?vue&type=template&id=95b954ea"
import script from "./StockIndicator.vue?vue&type=script&lang=js"
export * from "./StockIndicator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports